
<template>
  <div>
    <div class="content-box">
      <div class="row element-wrapper">
        <div class="col-sm-12">
          <div class="element-box mb-0">
            <h5 class="form-header">Ordenes de Compras Pendientes</h5>
            <div class="row">
              <div class="col-md-12">
                <TiendaSelectComponent :current="current" />
              </div>
              <div class="col-sm-12">
                <div class="form-group">
                  <label
                    v-bind:class="{
                      'text-danger': current.errors && current.errors.producto,
                    }"
                  ></label>
                  <ProductoSelectComponent
                    :current="current"
                  ></ProductoSelectComponent>
                  <small
                    v-if="current.errors && current.errors.producto"
                    class="form-text text-danger"
                    >{{ current.errors.producto[0] }}</small
                  >
                </div>
              </div>
            </div>
            <div class="form-buttons-w">
              <div>
                <button
                  class="btn btn-md btn-success btn-block"
                  @click="refresh()"
                  v-if="current && current.tienda"
                >
                  Refrescar
                </button>
              </div>
              <br />
              <div>
                <button
                  class="btn btn-md btn-dark btn-block"
                  @click="cleanFilters"
                >
                  Limpiar
                </button>
              </div>
              <br />
              <router-link
                v-if="current.producto"
                class="btn btn-outline-info"
                :to="{
                  name: 'cat-productos-editar',
                  params: { sku: current.producto.sku },
                }"
              >
                <i class="fa fa-arrow-left"></i>
                Ir al Producto
              </router-link>
            </div>
            <div class="row">
              <div class="col-sm-12"></div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="element-wrapper">
            <div class="element-box">
              <br />
              <button
                type="button"
                v-if="datos"
                @click="imprimir(current)"
                class="btn btn-secondary btn-sm btn-block"
              >
                <span>Descargar en PDF</span>
              </button>
              <br />
              <br />
              <div class="table-responsive">
                <table class="table table-striped table-hover">
                  <thead>
                    <tr>
                      <th>Tienda</th>
                      <th>Sku</th>
                      <th>Descripcion</th>
                      <th class="text-center">Fecha</th>
                      <th class="text-right">Categoria</th>
                      <th class="text-right">SubCategoria</th>
                      <th class="text-right">Cantidad OC</th>
                      <th class="text-center">Cantidad Ingresada</th>
                      <th class="text-center">Pendiente de Ingreso</th>
                      <th class="text-center"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in datos" :key="item.id">
                      <td>{{ item.tienda_nombre }}</td>
                      <td>
                        <router-link
                          :to="{
                            name: 'inventario-reportes-kardex',
                            params: {
                              sku: item.producto_id,
                              tienda: item.tienda_id,
                            },
                          }"
                          class="font-weight-bold"
                          style="color: ForestGreen"
                        >
                          <i class="fas fa-external-link-alt"></i>&nbsp;
                          <span>{{ item.producto_id }}</span>
                        </router-link>
                      </td>
                      <td>{{ item.nombre_producto }}</td>
                      <td class="text-center">{{ item.fecha }}</td>
                      <td class="text-right">{{ item.nombre_categoria }}</td>
                      <td class="text-right">{{ item.nombre_subcategoria }}</td>
                      <td
                        style="color: Blue"
                        class="text-right font-weight-bold"
                      >
                        {{ item.cantidad }}
                      </td>
                      <td class="text-center">
                        {{ item.cantidad_ingresada }}
                      </td>
                      <td class="text-center">
                        {{ item.pendiente }}
                      </td>
                      <td>
                        <router-link
                          target="_blank"
                          :to="{
                            name: 'compras-ordencompra-editar',
                            params: { id: item.orden_e_id },
                          }"
                          class="btn btn-success btn-sm"
                          ><i class="fas fa-eye"></i
                        ></router-link>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";
import DynamicService from "@/services/commons/DynamicService";
import ProductoSelectComponent from "@/components/commons/ProductoSelectComponent";

export default {
  components: {
    TiendaSelectComponent,
    ProductoSelectComponent,
  },
  data() {
    return {
      current: {
        producto: null,
        sku: null,
        tienda: null,
        errors: {
          productos: null,
          fecha_inicial: null,
          fecha_final: null,
        },
      },
      datos: "",
    };
  },
  computed: {},
  mounted() {},
  methods: {
    cleanFilters() {
      this.current.producto = null;
      this.current.tienda = null;
      this.datos = "";
    },
    imprimir(current) {
      let self = this;
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      let params = self.current;
      if (self.current.producto != null) {
        params.sku = self.current.producto.sku;
        window.open(
          `${baseApiUrl}/cat/reporte/?report_format=pdf&report_name=compras/ordenes_compra/ordenCompraAbierta.jrxml&sku=${params.sku}&tienda=${params.tienda}`
        );
      } else {
        window.open(
          `${baseApiUrl}/cat/reporte/?report_format=pdf&report_name=compras/ordenes_compra/ordenCompraAbierta.jrxml&tienda=${params.tienda}`
        );
      }
    },
    refresh() {
      let self = this;
      let params = {
        tienda: self.current.tienda,
      };
      if (self.current.producto) {
        params.sku = self.current.producto.sku;
      }
      console.log(params)
      DynamicService.getActionList(
        "compras",
        "orden_compra_e",
        "productos_pendientes_recibir_ocs",
        params
      )
        .then((res) => {
          self.datos = res.data;
        })
        .catch((err) => {
          console.log(err.response.data);
        });
    },
  },
};
</script>
